<template>
<div>
	<div class="row">
		<div class="col-md-4 col-md-offset-4">
			<div class="logo">
				<img src="/img/gis_logo_v2.png" alt="">
			</div>
			<div class="login-panel panel panel-default logo-panel">
				<div class="panel-heading">
					<h3 class="panel-title">Bitte melden Sie sich an</h3>
				</div>
				<div class="panel-body">
					<form @submit.prevent="login">
						<fieldset>
							<div class="form-group" v-if="wrongAuth">
								<div class="alert alert-danger" role="alert">Benutzername und/oder Passwort fehlerhaft</div>
							</div>
							<div class="form-group">
								<input class="form-control" placeholder="Benutzername" name="user" autofocus required v-model="username">
							</div>
							<div class="form-group">
								<input class="form-control" placeholder="Passwort" name="password" type="password"  v-model="password" required>
							</div>
							<!-- Change this to a button or input when using this as a form -->
							<input type="submit" class="btn btn-lg btn-primary btn-block" value="Anmelden">
						</fieldset>
					</form>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
import axios from 'axios'

import { getToken, setToken, clearToken, getRoutes } from 'functions/auth_check.js'

export default {
	beforeRouteEnter(from, to, next) {
		if (getToken() === '') {
			next()
		} else {
			next('/dashboard/')
		}
	},

	// Normale Eigenschaften
	data () {
		return {
			username: "",
			password: "",
			wrongAuth: false
		}
	},

	methods: {
		login () {
			axios.post('/api/session/', {username: this.username, password: this.password})
			.then(res => {
				setToken(res.data)
				this.$router.replace('/' + getRoutes()[0].path + '/')
			})
			.catch(err => {
				if (err.response.status) {
					clearToken()
					this.wrongAuth = true
				}
			})
		}
	},

	activated () {
		this.username = ""
		this.password = ""
		this.wrongAuth = false
	}
}
</script>

<style>
.logo {
	text-align: center;
}

.logo-panel {
	margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// LoginView.vue?5177eb36